import { createFileRoute, Link, Outlet, useParams } from '@tanstack/react-router'

import {
  CATALOGUE,
  CATALOGUE_KINDS,
  useCatalogueCount,
  type CatalogueKind,
} from '@/features/catalogue/kinds'
import { cn } from '@/lib/utils'

export const Route = createFileRoute('/catalogue')({ component: CatalogueLayout })

/**
 * Setup › Catalogue (screen 3e): the seven kinds of reference data on one
 * screen, picked from a rail. Trees and flat lists keep their own editors.
 */
function CatalogueLayout() {
  const params = useParams({ strict: false }) as { kind?: string }
  return (
    <div className="grid min-h-full grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)]">
      <nav
        aria-label="Catalogue"
        className="border-divider flex gap-1 overflow-x-auto border-b px-3 py-3 md:flex-col md:gap-0.5 md:border-r md:border-b-0 md:py-4"
      >
        <h6 className="hidden px-1.5 pb-2 text-neutral-600 md:block">Catalogue</h6>
        {CATALOGUE_KINDS.map((kind) => (
          <RailItem key={kind} kind={kind} active={params.kind === kind} />
        ))}
      </nav>
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  )
}

function RailItem({ kind, active }: { kind: CatalogueKind; active: boolean }) {
  const count = useCatalogueCount(kind)
  return (
    <Link
      to="/catalogue/$kind"
      params={{ kind }}
      aria-current={active ? 'page' : undefined}
      className={cn(
        'flex shrink-0 items-baseline gap-1.5 px-1.5 py-1.5 text-sm whitespace-nowrap',
        active ? 'bg-steel-100 text-steel-700' : 'hover:bg-foreground/5',
      )}
    >
      {CATALOGUE[kind].title}
      {count !== undefined && <span className="tabular text-neutral-600">{count}</span>}
    </Link>
  )
}
